<template>
  <div>
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="linkFamily"
      title="VINCULAR FAMILIARES"
      :size="isNotCustomerHasResident.length == 0 ? 'md' : 'xl'"
    >
      <b-overlay :show="loadingIsNotCustomerHasResident" opacity="0.99">
        <div
          class="v-clean p-5 text-center col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          v-if="isNotCustomerHasResident.length == 0"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div v-if="isNotCustomerHasResident.length > 0">
          <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 p-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR FAMILIARES"
              outlined
              dense
            ></v-text-field>
          </div>
          <v-data-table
            dense
            :headers="[
              { text: 'NOME', value: 'customer_name' },
              { text: 'GRAU DE PARENTESCO', value: 'type_of_customer_name' },
              { text: '', value: 'action' },
            ]"
            :items="isNotCustomerHasResident"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 25, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                small
                class="btn-edit"
                @click="createCustomerHasResident(item)"
              >
                <i class="fas fa-pencil-alt mr-2 text-twenty"></i> VINCULAR
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </b-overlay>
    </b-modal>
    <b-overlay :show="loadingCustomerHasResident" opacity="0.99">
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-7 col-12 pb-0 d-flex justify-content-start align-items-center"
        >
          <h6 class="title-pages mb-0">FAMILIARES VINCULADOS</h6>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12 d-flex justify-content-end align-items-center"
        >
          <v-btn class="btn-add" @click="$bvModal.show('linkFamily')">
            <i class="fas fa-plus mr-2 text-twenty"></i> VINCULAR
          </v-btn>
        </div>
        <ErrorsMessages :errors="errors" />
      </div>
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center v-clean p-5"
        v-if="isCustomerHasResident.length == 0"
      >
        <h6 class="upper-text worksansr">Nenhum familiar vinculado!</h6>
      </div>
      <div class="row">
        <v-list-item
          two-line
          v-for="(item, key) in isCustomerHasResident"
          :key="key"
        >
          <v-list-item-content>
            <div class="row" style="border: 1px solid #ddd">
              <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-12">
                <h6 class="worksansr upper-text">
                  {{ item.customer_name }}<br />Grau de parentesco:
                  <b>{{ item.type_of_customer_name }}</b>
                </h6>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                <div class="row align-items-center">
                  <h6
                    :for="`responsible_for_payment_${item.customer_id}`"
                    class="mr-2 mt-2 worksansr upper-text"
                  >
                    Responsável pelo pagamento?
                  </h6>
                  <input
                    :id="`responsible_for_payment_${item.customer_id}`"
                    type="checkbox"
                    :checked="item.responsible_for_payment"
                    :ref="`responsible_for_payment_${item.customer_id}`"
                    @click="handleChangeResponsibleForPayment(item)"
                  />
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 d-flex justify-content-end align-items-center"
              >
                <ConfirmationDialog
                  headerClass="modal-header-red"
                  message-title="REMOVER?"
                  message-body="Deseja realmente remover vinculo do residente com familiar?"
                  open-class="btn-delete"
                  open-left-icon="fa-times"
                  openText="EXCLUIR"
                  @yes="deleteCustomerHasResident(item.customer_id)"
                />
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </div>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ErrorsMessages from "../../templates/Components/ErrorsMessages";

import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

export default {
  name: "CustomerHasResident",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
  },
  data() {
    return {
      search: "",
      customers: [],
      loadingIsNotCustomerHasResident: true,
      loadingCustomerHasResident: false,
      isCustomerHasResident: [],
      isNotCustomerHasResident: [],
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      if (this.errors.length == 0) await this.getCustomers();
      if (this.errors.length == 0) await this.getCustomerHasResident();
      if (this.errors.length == 0) await this.getNotCustomerHasResident();
    },
    async getCustomers() {
      try {
        const response = await api.get("/rest-home/customers");

        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.customers = customers;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getNotCustomerHasResident() {
      try {
        this.loadingIsNotCustomerHasResident = true;

        const { rest_home_id, resident_id } = this;

        const response = await api.get(
          "/rest-home/customer/unrelated-customers",
          {
            params: { rest_home_id, resident_id },
          }
        );

        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isNotCustomerHasResident = customers;
        }

        this.loadingIsNotCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomerHasResident() {
      try {
        this.loadingCustomerHasResident = true;

        const { resident_id } = this;

        const response = await api.get("/rest-home/customer/by-resident", {
          params: { resident_id },
        });

        const { error, errors, customerHasResident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isCustomerHasResident = customerHasResident;
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },
    async createCustomerHasResident({ customer_id }) {
      try {
        const { user_id, resident_id } = this;

        let params = { user_id, resident_id, customer_id };

        const response = await api.post(
          "/rest-home/customer/bind-resident",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.getNotCustomerHasResident();
          this.$bvModal.hide("linkFamily");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteCustomerHasResident(customer_id) {
      try {
        const { user_id, resident_id } = this;

        let data = { user_id, customer_id, resident_id };

        const response = await api.delete(
          "/rest-home/customer/unbind-resident",
          {
            data,
          }
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.getNotCustomerHasResident();
        } else {
          toast(message, "error");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleChangeResponsibleForPayment(item) {
      try {
        const { resident_id } = this;
        const { customer_id } = item;

        var responsible_for_payment =
          this.$refs[`responsible_for_payment_${customer_id}`][0].checked;

        let params = { resident_id, customer_id, responsible_for_payment };

        const response = await api.post(
          "/rest-home/customer/responsible-for-payment/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleChangeGuarantor(item) {
      try {
        const { resident_id } = this;
        const { customer_id } = item;

        var guarantor = this.$refs[`guarantor_${customer_id}`][0].checked;

        let params = { resident_id, customer_id, guarantor };

        const response = await api.post(
          "/rest-home/customer/guarantor/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
